import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationStore } from 'src/app/stores/authentication.store';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent {
  @Input() currentURL: String = null;
  constructor(
    private route: Router,
    private authenticationStore: AuthenticationStore
  ) {}
  async tablinks(link: string) {
    if (link == 'account' || link == 'dashboard') {
      this.route.navigate(['/' + link]);
    } else {
      var resp = await this.authenticationStore.requiredLogin();
      resp && this.route.navigate(['/' + link]);
    }
  }

 async goToSeller() {
    var resp = await this.authenticationStore.requiredLogin();
    if (resp) {
      if (
        this.authenticationStore &&
        this.authenticationStore.userInfo &&
        this.authenticationStore.userInfo.seller
      ) {
        this.route.navigate(['/seller/my-shop']);
      } else {
        this.route.navigate(['/seller']);
      }
    }
  }
}
